import { BackgroundActivityErrorAlert } from "app/modules/backgroundActivities/components/BackgroundActivityErrorAlert";
import { APIStatusBanner } from "app/system/apiStatus/APIStatusBanner";
import { LicenceBanner } from "app/system/licenceCheck/LicenceBanner";
import { ConnectMaintenanceNotification } from "app/system/maintenance/MaintenanceBanners";
import { SignalRAlert } from "signalR/notifications/SignalRAlert";

export function HeaderNotifications({ externalAccess = false }: { externalAccess?: boolean }) {
  return (
    <div id="header-notification-container" className="container">
      {!externalAccess && <LicenceBanner />}
      <ConnectMaintenanceNotification />
      <APIStatusBanner />
      <BackgroundActivityErrorAlert />
      <SignalRAlert />
    </div>
  );
}
